import { useContext } from 'react';
import QueryParamsContext from './QueryParamsContext';

const useQueryParamsContext = () => {
  const context = useContext(QueryParamsContext);

  if (!context) {
    throw new Error(
      'useQueryParamsContext must be used within a QueryParamsProvider'
    );
  }

  return context;
};

export default useQueryParamsContext;
